import Button from "@/components/Button/index";
import Modal from "@/dsComponents/Modal";
import { ModalBody, ModalFooter, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";

export const ResetNotificationModal = ({
	isModalVisible,
	hideModal,
	confirmCallback,
}) => {
	const handleSubmitBtnClicked = async () => {
		hideModal();
		confirmCallback();
	};

	return (
		<Modal visible={isModalVisible} close={hideModal}>
			<ModalHeader>
				<ModalTitle>Reset to default</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div>
					Do you want to reset all notifications to default
					settings?
				</div>
			</ModalBody>
			<ModalFooter>
				<ModalFooterRight>
					<Button data-testid="cancel-btn" ghost text="Cancel" submit={hideModal} />
					<Button
						data-testid="reset-btn"
						error
						text="Reset"
						submit={handleSubmitBtnClicked}
					/>
				</ModalFooterRight>
			</ModalFooter>
		</Modal>
	);
};
